import { render } from "./CategoryResults360.vue?vue&type=template&id=2522c15b"
import script from "./CategoryResults360.vue?vue&type=script&lang=js"
export * from "./CategoryResults360.vue?vue&type=script&lang=js"

import "./CategoryResults360.vue?vue&type=style&index=0&id=2522c15b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__